// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountDetailsStyles from "@sc/App/SharedStyles/MyAccountDetailsStyles";
import { rfqQuoteDetailsHeaderStyles } from "@sc/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsHeader";
import { css } from "styled-components";

rfqQuoteDetailsHeaderStyles.headerGridContainer = {
    gap: 0,
};

rfqQuoteDetailsHeaderStyles.title = {
    variant: "h3",
    as: "h1",
    css: css`
        @media print {
            font-size: 11px;
        }
    `,
};

rfqQuoteDetailsHeaderStyles.buttonGridItem = {
    width: 12,
    css: css`
        gap: 16px 24px;
        flex-wrap: wrap;
        align-items: center;
    `,
};

rfqQuoteDetailsHeaderStyles.printLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.printLink,
};

rfqQuoteDetailsHeaderStyles.acceptQuoteLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.acceptLink,
};

rfqQuoteDetailsHeaderStyles.declineQuoteLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.removeAllLink,
};

rfqQuoteDetailsHeaderStyles.deleteQuoteLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.removeAllLink,
};

rfqQuoteDetailsHeaderStyles.submitQuoteLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.placeOrderLink,
};
